import * as Website from '../Config/Website.js';

const load = () => {
  Website.status.winWidth = window.innerWidth;
  Website.status.winHeight = window.innerHeight;
  Website.status.docWidth = document.body.clientWidth;
  Website.status.docHeight = document.body.clientHeight;
  Website.status.scrollY = window.pageYOffset;
  Website.status.scrollCurrent = Website.status.scrollY;
  Website.status.scrollRate = 0;


  if(Website.status.url.indexOf('localhost') > -1) {
    Website.status.isLocal = true;
  } else {
    Website.status.isLocal = false;
  }
  if(Website.status.url.indexOf('testing-web') > -1 || Website.status.url.indexOf('develop-web') > -1) {
    Website.status.isStage = true;
  } else {
    Website.status.isStage = false;
  }

  if(document.querySelector('link[rel="https://api.w.org/"]')) {
    Website.status.wp = document.querySelector('link[rel="https://api.w.org/"]').href;
  }


}

const resize = () => {
  Website.status.winWidth = window.innerWidth;
  Website.status.winHeight = window.innerHeight;
  Website.status.docWidth = document.body.clientWidth;
  Website.status.docHeight = document.body.clientHeight;
  Website.status.ua = navigator.userAgent.toLowerCase();
  Website.status.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
}

const scroll = () => {
  Website.status.scrollY = window.pageYOffset;
  Website.status.scrollRate = Website.status.scrollY - Website.status.scrollCurrent;
  Website.status.scrollCurrent = Website.status.scrollY;
}

export {
  load,
  resize,
  scroll
}